<template>
    <div v-if="$page.props.auth.user">
        <div class="ml-3 relative">
            <jet-dropdown align="right" width="48" class="theme--light">
                <template #trigger>
                    <v-card light style="border-radius: 50px">
                        <button
                            class="flex align-center text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out"
                        >
                            <img
                                class="h-8 w-8 rounded-full object-cover"
                                :src="$page.props.auth.user.profile_photo_url"
                                :alt="$page.props.auth.user.name"
                            />
                            <div
                                class="mx-1 flex align-center"
                                style="line-height: 12px"
                            >
                                {{ $page.props.auth.user.first_name }}
                            </div>
                            <v-icon dense color="dark">expand_more</v-icon>
                        </button>
                    </v-card>
                </template>

                <template #content>
                    <jet-dropdown-link
                        v-if="$page.props.auth.user"
                        :href="`/profile/${$page.props.auth.user.hash_id}/account`"
                        class="custom-dropdown-link"
                    >
                        View Profile
                    </jet-dropdown-link>
                    <jet-dropdown-link
                        href="/help-articles"
                        class="custom-dropdown-link"
                        >Help</jet-dropdown-link
                    >
                    <jet-dropdown-link
                        v-if="$page.props.auth.user"
                        @click="composeEmail = true"
                        class="custom-dropdown-link"
                        >Share Feedback</jet-dropdown-link
                    >
                    <jet-dropdown-link
                        href="/logout"
                        class="custom-dropdown-link error--text"
                    >
                        Logout
                    </jet-dropdown-link>
                </template>
            </jet-dropdown>
        </div>
        <ComposeEmail
            v-if="composeEmail"
            feedback
            :errors="errors"
            :user="$page.props.auth.user"
            @success="emailSuccess()"
            @reset="closeModal(() => (composeEmail = false))"
        />
    </div>
</template>

<script>
import JetDropdown from "../../Jetstream/Dropdown.vue";
import JetDropdownLink from "./../../Jetstream/DropdownLink";
import ComposeEmail from "../Users/ComposeEmail.vue";

export default {
    components: {
        JetDropdown,
        JetDropdownLink,
        ComposeEmail,
    },
    props: {
        errors: {},
    },
    data() {
        return {
            composeEmail: false,
        };
    },
    methods: {
        emailSuccess() {
            this.$emit("success");
            this.closeModal(() => (this.composeEmail = false));
        },
    },
};
</script>

<style scoped>
::v-deep .custom-dropdown-link > a {
    color: inherit !important;
}
</style>
